import { render, staticRenderFns } from "./EventsLayout.vue?vue&type=template&id=5196d018&"
import script from "./EventsLayout.vue?vue&type=script&lang=js&"
export * from "./EventsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5196d018')) {
      api.createRecord('5196d018', component.options)
    } else {
      api.reload('5196d018', component.options)
    }
    module.hot.accept("./EventsLayout.vue?vue&type=template&id=5196d018&", function () {
      api.rerender('5196d018', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Layouts/EventsLayout.vue"
export default component.exports